import useTranslation from 'next-translate/useTranslation';
import { GameSearchModalHeaderProps } from './props';
import styles from './styles.module.scss';

export default function GameSearchModalHeader({
  error,
  isLoading,
  count,
  currentAmount,
}: GameSearchModalHeaderProps) {
  const { t } = useTranslation('common');

  if (error) {
    return null;
  }

  return (
    <div className={styles.container}>
      <h4 className={styles.container__title}>{t('result_game_search')}</h4>

      {isLoading ? (
        <div className={styles.skeleton} />
      ) : (
        <p className={styles.container__text}>
          {t('result_count', {
            currentAmount,
            count,
          })}
        </p>
      )}
    </div>
  );
}
